import { StyledFormHelperText, StyledInputGrid } from "customStyled";

const FormInputOuter = ({ id, helperText, sx = {}, children }) => {
  return (
    <StyledInputGrid sx={{ ...sx }}>


      {children}

      {helperText ? (
        <StyledFormHelperText id={`${id}-helper-text`}>{helperText}</StyledFormHelperText>
      ) : null}
    </StyledInputGrid>
  );
};

export default FormInputOuter;
